import { Component, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { take, takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { ItemFormComponent } from "../item-form/item-form.component";
import { EntityListAction, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { SaleFormulaComponent } from "../../inv/sale-formula/sale-formula.component";
import { Item } from "../model/item.model";
import { AuthService, GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

@Component({
  selector: "ngx-item-list",
  templateUrl: "./item-list.component.html",
  styleUrls: ["./item-list.component.scss"],
})
export class ItemListComponent extends BaseListComponent {
  @ViewChild("grid") grid: KGridComponent;
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  unSortableFilterable: string[] = [];
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  actions: EntityListAction[];

  currentInformation = this.authService?.currentInformation();
  SoftWareLicenseKind = SoftWareLicenseKind;
  constructor(private tabsservice: TabularService, public authService: AuthService) {
    super();
    this.inputEditorform = ItemFormComponent;
    this.FillData();
  }
  ngOnInit() {
    this.apiName = "Item";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Catalog.Item.ItemsFormula");
    const columnsToExclude = ["SalePriceTypeTitle", "Price"];

    this.unSortableFilterable.push(...columnsToExclude);
    if (this.currentInformation.SepidzWebKind !== SoftWareLicenseKind.RestaurantLightWeb) {
      this.setactions();
    }
  }

  setactions() {
    this.actions = [
      {
        name: "SaleFormula",
        disabled: false,
        displayName: this.translate("ClientApp.FrontOffice.Catalog.Item.ComponentsOfGoods"),
        iconName: "icon-pie_chart-o",
        areaName: "RestaurantSale",
        isModal: false,
        requireSelectedrows: true,
        apiName: "SaleFormula/GetSaleFormula",
        Form_Component: SaleFormulaComponent,
        permission: Permission.samePermission,
      },
    ];
  }

  onActionClick(action: EntityListAction, selectedRow: Item, onRowsSelected: Item[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    if (action.name === "SaleFormula") {
      if (selectedRow) {
        this.httpCommonService
          .getItem("SaleFormula/GetFormulasByItemId", selectedRow.Id)
          .pipe(take(1))
          .subscribe((res) => {
            const menu = <ITab>{
              title: `${this.translate("ClientApp.FrontOffice.Catalog.Item.Analyze")} (${selectedRow.Title})`,
              isCloseable: true,
              icon: "",
              active: true,
              responsive: true,
              componentType: SaleFormulaComponent,
              data: [{ provide: VoucherKindInfo, useValue: { ItemId: selectedRow.Id, itemTitle: selectedRow.Title, formulas: res } }],
            };
            this.tabsservice.open(menu);
          });
      } else this.sts.showToast("warning", "", this.translate("ClientApp.FrontOffice.Catalog.Item.SelectAnItem"), 3000);
    }
  }

  async FillData() {
    const currentBranch = this.accountService.authService.currentInformation();
    if (currentBranch.RestaurantCallCenter) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Item")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (!this.accountService.authService.currentBranch.AccessToAllBranches && hbc.BranchCount != 1) {
            this.isAdd = false;
            this.isEdit = false;
            this.isDelete = false;
          }
        });
    }
    if (currentBranch.BranchingLightEnabled || currentBranch.BranchingAdvancedEnabled) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Item")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (!this.accountService.authService.currentBranch.AccessToAllBranches && hbc.BranchCount != 1) {
            this.isAdd = false;
            this.isEdit = false;
            this.isDelete = false;
          }
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.IgnoreDelete = true;
              this.deleteMessage = this.translate("ClientApp.FrontOffice.Catalog.Item.HasBranchCommunication");
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.IgnoreDelete = true;
                this.deleteMessage = this.translate("ClientApp.FrontOffice.Catalog.Item.HasCallCenterCommunication");
                return;
              }
            }
          }
        });
    }
  }

  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve({ GridInfo: this.getGridInfo(this.grid.grid.columns.toArray()), Filters: this.grid.getGridFilter() });
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
